import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { UserCreatePayload } from '../models/user-create-model';
import { ServiceCreatePayload } from '../models/service-create-model';
import { ServiceCreateResponse } from '../models/service-create-response-model';

@Injectable({
  providedIn: 'root',
})
export class ServiceMasterService {
  constructor(private http: HttpClient) {}

  lFN_GetServiceList() {
    return this.http.get(`${environment.ROOT_URL}/service/services`, {
      withCredentials: false,
      responseType: 'text',
      observe: 'response',
    });
  }

  lFN_SaveService(
    payload: ServiceCreatePayload
  ): Observable<HttpResponse<ServiceCreateResponse>> {
    return this.http.post<ServiceCreateResponse>(
      `${environment.ROOT_URL}/service/create-update`,
      payload,
      {
        observe: 'response',
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }
    );
  }

  lFN_GetServiceById(serviceHdrId: number) {
    return this.http.get(`${environment.ROOT_URL}/service/service-header-id/${serviceHdrId}`, {
      withCredentials: false,
      responseType: 'text',
      observe: 'response',
    });
  }

  lFN_ToggleServiceStatus(serviceHdrId: number) {
    return this.http.patch(
      `${environment.ROOT_URL}/service/status/${serviceHdrId}`,
      {},
      { observe: 'response', responseType: 'json' }
    );
  }

}
